module.exports = __webpack_public_path__ + "img/highSpeedRail-3.404cc942.jpg";